import * as React from 'react';
import Anchor from '@telia-front/anchor';
import Icon from '@telia-front/icon';
import ScrollFade from '@telia-front/scroll-fade';
import Tooltip from '@telia-front/tooltip';
class Pagination extends React.Component {
    constructor(props) {
        super(props);
        this.statusButton = React.createRef();
        this.goTo = (page, event) => {
            event.preventDefault();
            if (this.props.onChange) {
                this.props.onChange(page);
            }
            if (this.state.tooltipIsShown) {
                this.hideTooltip();
            }
        };
        this.hideTooltip = () => {
            this.setState({
                tooltipIsShown: false,
            });
        };
        this.handleTooltipToggle = (isShown) => {
            this.setState({
                tooltipIsShown: isShown,
            });
        };
        this.state = {
            tooltipIsShown: false,
        };
    }
    BEM(isTooltip = false) {
        const classArray = ['pagination'];
        if (this.props.color) {
            classArray.push('pagination--' + this.props.color);
        }
        if (this.props.style) {
            classArray.push('pagination--' + this.props.style);
        }
        if (this.props.position) {
            classArray.push('pagination--' + this.props.position);
        }
        if (isTooltip) {
            classArray.push('is-tooltip');
        }
        if (this.props.className) {
            classArray.push(this.props.className);
        }
        return classArray.join(' ');
    }
    getUrl(page) {
        if (!this.props.hrefBuilder) {
            return '#' + page;
        }
        return this.props.hrefBuilder(page);
    }
    renderPages(limit = 0) {
        const items = [];
        const asideLimit = Math.floor((limit - 1) / 2);
        const leftAdditional = asideLimit - Math.min(asideLimit + 1, this.props.pages - this.props.currentPage);
        const rightAdditional = asideLimit - Math.min(asideLimit + 1, this.props.currentPage - 1);
        const left = this.props.currentPage - asideLimit - leftAdditional;
        const right = this.props.currentPage + asideLimit + rightAdditional;
        let breakView;
        if (!limit) {
            for (let i = 1; i <= this.props.pages; i += 1) {
                items.push(this.renderPage(i));
            }
        }
        else {
            for (let index = 1; index <= this.props.pages; index++) {
                if (index === 1 || index === this.props.pages) {
                    items.push(this.renderPage(index));
                    continue;
                }
                if (index >= left && index <= right) {
                    items.push(this.renderPage(index));
                    continue;
                }
                if (items[items.length - 1] !== breakView) {
                    breakView = this.renderBreak(index);
                    items.push(breakView);
                }
            }
        }
        return items;
    }
    renderBreak(index) {
        return (React.createElement("li", { className: "pagination__item", key: index },
            React.createElement("span", { className: "pagination__break" }, "...")));
    }
    renderPage(page) {
        let classNames = 'pagination__item';
        if (this.props.currentPage === page) {
            classNames += ' is-active';
        }
        return (React.createElement("li", { className: classNames, key: page },
            React.createElement(Anchor, { className: "pagination__link", onClick: this.goTo.bind(null, page), url: this.getUrl(page), isUnderlined: false }, page)));
    }
    renderPrevLink() {
        let page = this.props.currentPage - 1;
        let classNames = 'pagination__prev';
        if (this.props.currentPage <= 1) {
            page = this.props.currentPage;
            classNames += ' is-disabled';
        }
        return (React.createElement("li", { className: classNames },
            React.createElement(Anchor, { className: "pagination__link", onClick: this.goTo.bind(null, page), url: this.getUrl(page) },
                React.createElement("span", { className: "sr-only" }, page),
                React.createElement(Icon, { className: "pagination__icon", size: "xxs", modifiers: "#arrow-left" }))));
    }
    renderNextLink() {
        let page = this.props.currentPage + 1;
        let classNames = 'pagination__next';
        if (this.props.currentPage >= this.props.pages) {
            page = this.props.currentPage;
            classNames += ' is-disabled';
        }
        return (React.createElement("li", { className: classNames },
            React.createElement(Anchor, { className: "pagination__link", onClick: this.goTo.bind(null, page), url: this.getUrl(page) },
                React.createElement("span", { className: "sr-only" }, page),
                React.createElement(Icon, { className: "pagination__icon", size: "xxs", modifiers: "#arrow-right" }))));
    }
    renderStatus() {
        const tooltipVariant = this.props.style === 'inverse' ? 'white' : 'light';
        const tooltipBEM = () => {
            const classArray = ['tooltip--pagination'];
            classArray.push(`tooltip--pagination-${tooltipVariant}`);
            return classArray.join(' ');
        };
        return (React.createElement("li", { className: "pagination__status" },
            React.createElement("button", { className: "pagination__status-button", type: "button", ref: this.statusButton }, this.props.currentPage + ' / ' + this.props.pages),
            this.statusButton.current && (React.createElement(Tooltip, { trigger: "click", placement: "bottom", className: tooltipBEM(), isShown: this.state.tooltipIsShown, color: this.props.color, onToggle: this.handleTooltipToggle, referenceElement: this.statusButton.current },
                React.createElement("div", { className: this.BEM(true) },
                    React.createElement(ScrollFade, { variant: tooltipVariant },
                        React.createElement("ul", { className: "pagination__tooltip" }, this.props.pages && this.renderPages())))))));
    }
    render() {
        return (React.createElement("ul", { className: this.BEM() },
            this.renderPrevLink(),
            this.renderStatus(),
            this.props.pages && this.renderPages(this.props.displayedPages),
            this.renderNextLink()));
    }
}
Pagination.defaultProps = {
    displayedPages: 7,
};
export default Pagination;
